import { Button } from "shared/components/atoms/Button";
import { BaseModal } from "shared/components/organisms/modal/BaseModal";

interface Props {
  onSubmit: () => void;
}

export const DeleteCardModal = ({ onSubmit }: Props) => {
  return (
    <BaseModal
      title={`現在のカード情報は削除されますが\nよろしいですか？`}
      subTitle="ご登録クレジットカードを変更すると現在ご登録いただいているカード情報は削除されます。別のカードのご利用をご希望の方はOKを押して再度カード情報をご入力ください。"
    >
      <Button tw="w-full bg-gradient-theme-to-l" onClick={onSubmit}>
        OK
      </Button>
    </BaseModal>
  );
};
